import { useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, Loading } from "@/components/Common";
import { VendorDialog } from "@/components/VendorPicker";
import { useLoad } from "@/hooks/useData";
import { api, errMsg } from "@/lib/api";

export default function Vendors() {
  const { data, reload } = useLoad(() => api.get("/suppliers").then((r) => r.data));
  const [edit, setEdit] = useState({ open: false, vendor: null });
  if (!data) return <Loading />;
  const del = async (v) => {
    if (!window.confirm(`Delete vendor ${v.name}? Past orders keep the name.`)) return;
    try { await api.delete(`/suppliers/${v.id}`); toast.success("Vendor deleted"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="vendors-page">
      <PageHeader title="Vendors" subtitle="Suppliers and workshops used on Purchase / Manufacturing Orders.">
        <Button size="sm" onClick={() => setEdit({ open: true, vendor: null })} data-testid="add-vendor-btn"><Plus className="h-4 w-4" /> Add vendor</Button>
      </PageHeader>
      <div className="panel overflow-auto">
        <table className="data-table" data-testid="vendors-table">
          <thead><tr><th>Name</th><th>GSTIN</th><th>Address</th><th></th></tr></thead>
          <tbody>{data.map((v) => (
            <tr key={v.id} data-testid={`vendor-row-${v.name_key}`}>
              <td className="wrap-cell font-medium product-name">{v.name}</td><td className="font-mono text-xs">{v.gstin}</td>
              <td className="wrap-cell text-xs product-name">{v.address}</td>
              <td className="whitespace-nowrap">
                <button className="p-1.5 text-muted-foreground hover:text-primary" onClick={() => setEdit({ open: true, vendor: v })} data-testid={`edit-vendor-${v.name_key}`}><Pencil className="h-4 w-4" /></button>
                <button className="p-1.5 text-muted-foreground hover:text-red-500" onClick={() => del(v)} data-testid={`delete-vendor-${v.name_key}`}><Trash2 className="h-4 w-4" /></button>
              </td>
            </tr>))}
            {!data.length && <tr><td colSpan={4} className="py-8 text-center text-sm text-muted-foreground">No vendors yet</td></tr>}</tbody>
        </table>
      </div>
      <VendorDialog open={edit.open} vendor={edit.vendor} onOpenChange={(o) => setEdit((s) => ({ ...s, open: o }))} onSaved={reload} />
    </div>
  );
}
